import * as React from 'react'
import { MuiTextFieldFormik } from '@sales-center/components'
import MenuItem from '@mui/material/MenuItem'
import { Field } from 'formik'
import {
  emailThresholdEntries,
  EmailThresholdEntry,
} from '@user/features/Activity/constants'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'

export function ReminderSelector({
  disabled = false,
}: {
  disabled?: boolean
} = {}) {
  return (
    <Stack>
      <Typography variant="body1" mt={2} fontSize={16}>
        Send Email Reminder
      </Typography>
      <Tooltip
        title={
          disabled
            ? 'Select a Due Date/Time in the future to enable reminders for this activity.'
            : ''
        }
        placement="top"
        arrow
        disableHoverListener={!disabled}
      >
        <div>
          <Field
            component={MuiTextFieldFormik}
            disabled={disabled}
            fullWidth
            name="reminderThreshold"
            select
            size="small"
            label="Alert"
            default="None"
            data-test-id={`activity-form-reminder-select`}
            inputProps={{
              'data-test-id': 'activity-form-reminder-select-input',
            }}
          >
            {emailThresholdEntries.map((entry: EmailThresholdEntry) => (
              <MenuItem value={entry.value} key={entry.value}>
                {entry.name}
              </MenuItem>
            ))}
          </Field>
        </div>
      </Tooltip>
    </Stack>
  )
}
